import React from 'react';
import { TabContainer } from '@src/components/global/TabContainer';
import { ResponseDetailContainerController } from './ResponseDetailContainer.Controller';
import { ResponseDetail } from '@src/components/pages/Response/ResponseDetail/Detail';
import { ActivityLogGrid } from '@src/components/pages/Response/ResponseDetail/ActivityLog';

export const ResponseDetailContainer = () => {
  const { addons, sourceSessionId } = ResponseDetailContainerController();

  const DetailComponent = <ResponseDetail />;
  const ActivityLogComponent = (
    <ActivityLogGrid sourceSessionId={sourceSessionId} />
  );

  const getTabComponent = (code: string) => {
    switch (code) {
      case 'DETAIL':
        return DetailComponent;
      case 'ACTIVITY_LOG':
        return ActivityLogComponent;
      default:
        return null;
    }
  };

  return (
    <div className="response-detail-tabs">
      <TabContainer
        title="Response Detail"
        addons={addons}
        getTabComponent={getTabComponent}
      />
    </div>
  );
};
